import React from 'react'
import {
  Input,
} from 'react-toolbox/lib/input'
import connect from '../../connects/user-email-panel'
import {
  Card,
  CardText,
  CardTitle,
  CardActions,
  CardMedia,
} from 'react-toolbox/lib/card'
import {
  Button
} from 'react-toolbox/lib/button'
import {
  translate
} from 'react-i18next'
import {
  linkUI
} from '../../helpers/form-validator'
import theme from './themes/flat-card.css'

class UserEmailPanel extends React.Component{
render() {
    const {
      t,
      user,
      ui,
      isEmailUpdating,
      updateUI,
      validateAndSubmit,
    } = this.props // declare all props here to easy to see what props should be passed.
    return (
    <Card theme={theme}>
      <form onSubmit={(e)=> validateAndSubmit(this.props, e)}>
        <CardText>
          <normal><strong>メールアドレス</strong></normal>
          <Input name="email" required
              label={t('label:メールアドレス')}
              value={ui.email}
              icon='email'
              error={ui.emailError &&t('error:メールアドレスを入力してください')}
              onChange={linkUI(this, 'email')} />
          {user && user.unconfirmed_email &&
            <span>{t('label:メールアドレス確認待ち', { email: user.unconfirmed_email })}</span>
          }
        </CardText>
        <CardActions>
            <Button raised primary
                disabled={isEmailUpdating}
                type="submit"
                style={{ width: '100%' }}
                label={t('label:更新')} />
        </CardActions>
      </form>
    </Card>
    )
}
}


export const RawUserEmailPanel = UserEmailPanel
export default connect(UserEmailPanel)



// WEBPACK FOOTER //
// ./src/web/components/user-email-panel.jsx